import {useRef, useEffect} from 'react';

/**
 * Only runs the effect on updates, not on mount.
 * @param effect Function to run on updates
 * @param dependencies Dependencies to watch for changes
 * @example
 * ```tsx
 * const [count, setCount] = useState(0);
 * useUpdateEffect(() => {
 *   console.log('Count updated:', count);
 * }, [count]);
 * ```
 */
export const useUpdateEffect = (
	effect: Function,
	dependencies?: React.DependencyList,
) => {
	const isInitialMount = useRef(true);
	const effectRef = useRef(effect);
	useEffect(() => {
		effectRef.current = effect;
	});

	useEffect(() => {
		if (isInitialMount.current) {
			isInitialMount.current = false;
			return;
		}
		return effectRef.current();
	}, dependencies);
};

export default useUpdateEffect;
